import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

// Register service worker for PWA functionality
serviceWorkerRegistration.register({
  onUpdate: (registration) => {
    // New content is available, show update notification
    const updateBanner = document.createElement('div');
    updateBanner.className = 'pwa-install-prompt';
    updateBanner.innerHTML = `
      <span>Eine neue Version ist verfügbar!</span>
      <div>
        <button onclick="window.location.reload()">Aktualisieren</button>
        <button class="dismiss" onclick="this.parentElement.parentElement.remove()">Später</button>
      </div>
    `;
    document.body.appendChild(updateBanner);
  },
  onSuccess: (registration) => {
    console.log('PWA: App ist jetzt offline verfügbar');
  }
});
